// @flow
import React, { useState, useCallback } from 'react';

import { navigate } from '../../lib/helpers';
import { currentMaintenanceCostApi } from '../../lib/api';
import { type CurrentMaintenanceCost } from '../../lib/types';

import CommonCardPage from '../../components/hoc/common/handbook/CardPage';
import { InnerForm } from './components';
import { getBreadCrumbsByUrlForEdit } from '../../lib/autoBreadcrumbs';

type PageProps = {
  id: number
};

const entryPointPath = '/admin/current-maintenance-cost/';

export default (props: PageProps) => {
  const [data: CurrentMaintenanceCost, setData] = useState({
    id: props.id
  });

  const breadCrumbs = getBreadCrumbsByUrlForEdit(entryPointPath, props.id);

  const onFetch = useCallback(async () => {
    !!props.id && setData(await currentMaintenanceCostApi.get(props.id));
  }, [props.id]);

  const onSubmit = async (payload: CurrentMaintenanceCost) => {
    let id = payload.id;
    if (id) {
      await currentMaintenanceCostApi.update(payload);
    } else {
      let data = await currentMaintenanceCostApi.add(payload);
      id = data.id;
    }
    await navigate(`${entryPointPath}${id}`);
  };

  const onCancel = async (payload: CurrentMaintenanceCost) => {
    if (data.id) {
      await navigate(`${entryPointPath}${data.id}`);
    } else await navigate(`${entryPointPath}`, true);
  };

  return (
    <CommonCardPage
      pageHeaderProps={{
        breadCrumbs,
        mainHeader: 'Стоимость текущего ремонта'
      }}
      onFetch={onFetch}
      onSubmit={onSubmit}
      onCancel={onCancel}
    >
      <InnerForm data={data} useFooter noWrapMe />
    </CommonCardPage>
  );
};
